import Vue from 'vue';
import App from './App.vue';
import './quasar';
import store from './store/store';
import router from './router/router';
import 'normalize.css/normalize.css';
import './assets/fontawesome-pro-5.13.0-web/css/all.min.css';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
